"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsApi = exports.ProductsApiFactory = exports.ProductsApiFp = exports.ProductsApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * ProductsApi - axios parameter creator
 * @export
 */
var ProductsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a blank product. The product cannot be used as long    as it is missing product factors, insured objects and premium formulas.
         * @summary Create the product
         * @param {CreateProductRequestDto} createProductRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (createProductRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createProductRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createProduct', 'createProductRequestDto', createProductRequestDto);
                            localVarPath = "/insuranceservice/v1/products";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createProductRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Permanently deletes the product. Supply the unique id that was returned when you created the product and this will delete it.
         * @summary Delete the product
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: function (id, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteProduct', 'id', id);
                            localVarPath = "/insuranceservice/v1/products/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
         * @summary Retrieve the product
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [id] Unique identifier referencing the product.
         * @param {string} [slug] A slug is a human-readable, unique identifier, used to identify a resource     instead of a less human-readable identifier like an id.
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByCode: function (code, authorization, id, slug, expand, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'code' is not null or undefined
                            (0, common_1.assertParamExists)('getProductByCode', 'code', code);
                            localVarPath = "/insuranceservice/v1/products/code/{code}"
                                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (slug !== undefined) {
                                localVarQueryParameter['slug'] = slug;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
         * @summary Retrieve the product
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [id] Unique identifier referencing the product.
         * @param {string} [code] Unique identifier of the product that this object belongs to.
         * @param {string} [slug] A slug is a human-readable, unique identifier, used to identify a resource     instead of a less human-readable identifier like an id.
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdentifier: function (authorization, id, code, slug, expand, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/products/get-by-identifier";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (slug !== undefined) {
                                localVarQueryParameter['slug'] = slug;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of products you have previously created.        The products are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List products
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] List filter
         * @param {string} [search] Search query.
         * @param {string} [order] Ordering criteria.
         * @param {string} [expand] You can expand product versions and insured object types list in this endpoint. By default, versions &amp; insuredObjectTypes will be an empty array.
         * @param {string} [filters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/products";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the specified product by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the product
         * @param {number} id
         * @param {UpdateProductRequestDto} updateProductRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (id, updateProductRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateProduct', 'id', id);
                            // verify required parameter 'updateProductRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('updateProduct', 'updateProductRequestDto', updateProductRequestDto);
                            localVarPath = "/insuranceservice/v1/products/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ProductsApiAxiosParamCreator = ProductsApiAxiosParamCreator;
/**
 * ProductsApi - functional programming interface
 * @export
 */
var ProductsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProductsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a blank product. The product cannot be used as long    as it is missing product factors, insured objects and premium formulas.
         * @summary Create the product
         * @param {CreateProductRequestDto} createProductRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (createProductRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createProduct(createProductRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Permanently deletes the product. Supply the unique id that was returned when you created the product and this will delete it.
         * @summary Delete the product
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: function (id, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteProduct(id, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
         * @summary Retrieve the product
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [id] Unique identifier referencing the product.
         * @param {string} [slug] A slug is a human-readable, unique identifier, used to identify a resource     instead of a less human-readable identifier like an id.
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByCode: function (code, authorization, id, slug, expand, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductByCode(code, authorization, id, slug, expand, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
         * @summary Retrieve the product
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [id] Unique identifier referencing the product.
         * @param {string} [code] Unique identifier of the product that this object belongs to.
         * @param {string} [slug] A slug is a human-readable, unique identifier, used to identify a resource     instead of a less human-readable identifier like an id.
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdentifier: function (authorization, id, code, slug, expand, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductByIdentifier(authorization, id, code, slug, expand, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of products you have previously created.        The products are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List products
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] List filter
         * @param {string} [search] Search query.
         * @param {string} [order] Ordering criteria.
         * @param {string} [expand] You can expand product versions and insured object types list in this endpoint. By default, versions &amp; insuredObjectTypes will be an empty array.
         * @param {string} [filters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listProducts(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the specified product by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the product
         * @param {number} id
         * @param {UpdateProductRequestDto} updateProductRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (id, updateProductRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateProduct(id, updateProductRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ProductsApiFp = ProductsApiFp;
/**
 * ProductsApi - factory interface
 * @export
 */
var ProductsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProductsApiFp)(configuration);
    return {
        /**
         * Create a blank product. The product cannot be used as long    as it is missing product factors, insured objects and premium formulas.
         * @summary Create the product
         * @param {CreateProductRequestDto} createProductRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (createProductRequestDto, authorization, options) {
            return localVarFp.createProduct(createProductRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Permanently deletes the product. Supply the unique id that was returned when you created the product and this will delete it.
         * @summary Delete the product
         * @param {number} id
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: function (id, authorization, options) {
            return localVarFp.deleteProduct(id, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
         * @summary Retrieve the product
         * @param {string} code Unique identifier for the object.
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [id] Unique identifier referencing the product.
         * @param {string} [slug] A slug is a human-readable, unique identifier, used to identify a resource     instead of a less human-readable identifier like an id.
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByCode: function (code, authorization, id, slug, expand, options) {
            return localVarFp.getProductByCode(code, authorization, id, slug, expand, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
         * @summary Retrieve the product
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [id] Unique identifier referencing the product.
         * @param {string} [code] Unique identifier of the product that this object belongs to.
         * @param {string} [slug] A slug is a human-readable, unique identifier, used to identify a resource     instead of a less human-readable identifier like an id.
         * @param {string} [expand] Fields to expand response by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductByIdentifier: function (authorization, id, code, slug, expand, options) {
            return localVarFp.getProductByIdentifier(authorization, id, code, slug, expand, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of products you have previously created.        The products are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List products
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {number} [pageSize] Page size.
         * @param {string} [pageToken] Page token.
         * @param {string} [filter] List filter
         * @param {string} [search] Search query.
         * @param {string} [order] Ordering criteria.
         * @param {string} [expand] You can expand product versions and insured object types list in this endpoint. By default, versions &amp; insuredObjectTypes will be an empty array.
         * @param {string} [filters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listProducts(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the specified product by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
         * @summary Update the product
         * @param {number} id
         * @param {UpdateProductRequestDto} updateProductRequestDto
         * @param {string} [authorization] Bearer Token: provided by the login endpoint under the name accessToken.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (id, updateProductRequestDto, authorization, options) {
            return localVarFp.updateProduct(id, updateProductRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProductsApiFactory = ProductsApiFactory;
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a blank product. The product cannot be used as long    as it is missing product factors, insured objects and premium formulas.
     * @summary Create the product
     * @param {ProductsApiCreateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.createProduct = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).createProduct(requestParameters.createProductRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Permanently deletes the product. Supply the unique id that was returned when you created the product and this will delete it.
     * @summary Delete the product
     * @param {ProductsApiDeleteProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.deleteProduct = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).deleteProduct(requestParameters.id, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
     * @summary Retrieve the product
     * @param {ProductsApiGetProductByCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProductByCode = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).getProductByCode(requestParameters.code, requestParameters.authorization, requestParameters.id, requestParameters.slug, requestParameters.expand, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the details of the product that was previously created. Supply the unique product code      that was returned when you created it and Emil Api will return the corresponding product information.
     * @summary Retrieve the product
     * @param {ProductsApiGetProductByIdentifierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.getProductByIdentifier = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ProductsApiFp)(this.configuration).getProductByIdentifier(requestParameters.authorization, requestParameters.id, requestParameters.code, requestParameters.slug, requestParameters.expand, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of products you have previously created.        The products are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
     * @summary List products
     * @param {ProductsApiListProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.listProducts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ProductsApiFp)(this.configuration).listProducts(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the specified product by setting the values of the parameters passed. Any parameters not provided will be left unchanged.
     * @summary Update the product
     * @param {ProductsApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.updateProduct = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).updateProduct(requestParameters.id, requestParameters.updateProductRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductsApi;
}(base_1.BaseAPI));
exports.ProductsApi = ProductsApi;
